export default "__VITE_ASSET__BCa0_AIf__"